import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconFormSeal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormSeal"><G ClipPath="url(#clip0_14456_27904)"><Path d="M15.3838 4.0752H19.9229V8.61426L23.3086 12L19.9229 15.3857V19.998H15.3789L11.998 23.2979L8.61133 19.9922L4.07324 19.9121V15.3857L0.6875 12L4.07324 8.61426V4.0752H8.6123L11.998 0.689453L15.3838 4.0752Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_14456_27904"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconFormSeal;
